export default "__VITE_ASSET__qlU259em__"